"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../../libs/hooks");

var Exclamation = function Exclamation(props) {
  var className = props.className,
      style = props.style;

  var _useTheme = (0, _hooks.useTheme)(),
      palette = _useTheme.rainbow.palette;

  var color = (0, _react.useMemo)(function () {
    return {
      background: palette.error.main,
      foreground: palette.getContrastText(palette.error.main)
    };
  }, [palette]);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    style: style,
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "components"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: color.background,
    cx: "10",
    cy: "10",
    r: "10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "translate(8.5, -2)",
    fill: color.foreground,
    d: "m1.57577 5.85161c-.552285 0-1 .453036-1 .99703v6.00594c0 .550645.443865.99703 1 .99703 .552285 0 1-.453036 1-.99703v-6.00594c0-.550644-.443865-.99703-1-.99703v0Zm0 12c.552285 0 1-.447715 1-1 0-.552285-.447715-1-1-1 -.552285 0-1 .447715-1 1 0 .552285.447715 1 1 1v0Z"
  })));
};

Exclamation.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
Exclamation.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = Exclamation;
exports["default"] = _default;